import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { Modal, Box, Typography } from "@mui/material"
import styles from "../Modals.module.css"
import { useApiService } from "../../hooks/Api/useApiService"
import SkillRating from "../../SkillRating/SkillsRating"
import ModalCloseButton from "../ModalCloseButton"
import T from "../../hooks/Language/T"

const RatingModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)
  const [ratings, setRatings] = useState([])
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const { postData } = useApiService()

  useEffect(() => {
    postData("skills/getskillratings", { skill: props.skill }).then((data) => {
      setRatings(data?.ratings)
    })
  }, [open])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <T>
        <ModalCloseButton handleClose={handleClose} />
        {ratings ? (
          <Box className={styles.modal_container}>
            {ratings?.map((rating, index) => {
              return (
                <SkillRating
                  key={index}
                  rating={rating.rating}
                  text={rating.text}
                  skillName={rating.name}
                  user_name={rating.from}
                />
              )
            })}
          </Box>
        ) : (
          <Box className={styles.modal_container}>
            <Typography>No Reviews Found!</Typography>
          </Box>
        )}
      </T>
    </Modal>
  )
})

export default RatingModal
